import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
  imageWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },

  image: {
    width: '192px',
    marginBottom: '20px',
  },
});
